import React from "react";
import { useTranslation } from "react-i18next";
import { BookOpenIcon } from "@heroicons/react/24/outline";

export const MaterialsManagementPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <BookOpenIcon className="w-16 h-16 text-tiber-500 mb-4" />
      <h1 className="text-2xl font-bold text-tiber-900 mb-2">
        {t("admin.materials.title")}
      </h1>
      <p className="text-juridico/80 max-w-md">
        {t("admin.settings.system.comingSoon")}
      </p>
    </div>
  );
};
